import { cloneDeep } from 'lodash';
import createModel from 'client/store/modules/models/createModel';

export const getDefaultItem = () => ({
  id: '',
  name: '',
  source: '',
  path: '',
  teamid: '',
});

export const createAppAuthorizationModel = () => {
  const model = createModel(getDefaultItem, 'id', {});

  return {
    namespaced: true,

    state: {
      ...model.state,
    },

    actions: {
      ...model.actions,

      // overrides default behaviour to fetch from collection module directly
      fetchItem({ commit, getters, rootGetters }) {
        const { id } = getters;

        if (id !== '') {
          const action = 'AppAuthorizationCollection/getItem';
          const item = rootGetters[action](id);

          commit('SET_ITEM', cloneDeep(item));
          commit('SET_PREVIOUS_ITEM', cloneDeep(item));
        }

        return Promise.resolve();
      },

      saveItem(context) {
        const { getters = {} } = context;
        const { item } = getters;

        context.commit('SET_ITEM', cloneDeep(item));
        context.commit('SET_PREVIOUS_ITEM', cloneDeep(item));
        context.commit('SET_ITEM_STATE', { update: true });

        return item;
      },

    },

    getters: {
      ...model.getters,

      displayName(state = { item: {} }) {
        const { id } = state.item;
        return id || '';
      },

    },

    mutations: {
      ...model.mutations,
    },
  };
};

export default createAppAuthorizationModel();
